import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { purpurColorFunctionalWhite, purpurColorGray700, purpurColorGray800, purpurColorPurple100, purpurColorPurple200, purpurColorRed100, purpurColorRed200, } from '@purpurds/tokens/color/variables';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import spacing from 'theme/spacing';
import { pxToRem } from 'theme/utils';
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: ${spacing.spacing16};
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.spacing12};
  text-align: center;
  width: 100%;
  max-width: ${pxToRem(320)};
  padding: 0 ${spacing.spacing16};
`;
const Card = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.spacing16};
  padding: ${spacing.spacing32} ${spacing.spacing24};
  border-radius: ${spacing.spacing8};
  border: 1.5px dashed 
    ${({ $variant }) => $variant === 'error' ? purpurColorRed100 : purpurColorPurple100};
`;
const IconWrapper = styled.div `
  width: ${pxToRem(48)};
  height: ${pxToRem(48)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: ${spacing.spacing8};
  background: ${({ $variant }) => $variant === 'error' ? purpurColorRed200 : purpurColorPurple200};

`;
const TextContainer = styled.div ``;
const Title = styled.p `
  font-size: 16px;
  font-weight: 500;
  color: ${purpurColorGray800};
  margin-bottom: ${spacing.spacing8};
`;
const Text = styled.p `
  font-size: 14px;
  color: ${purpurColorGray700};
  line-height: 1.5;
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorFunctionalWhite};
`;
export const EmptyState = ({ title, text, variant = 'empty' }) => {
    return (_jsx(Wrapper, { children: _jsx(Content, { children: _jsxs(Card, { "$variant": variant, children: [_jsx(IconWrapper, { "$variant": variant, children: _jsx(StyledIcon, { svg: variant === 'error' ? icons.error : icons.doc, size: 'md' }) }), _jsxs(TextContainer, { children: [_jsx(Title, { children: title }), _jsx(Text, { children: text })] })] }) }) }));
};
